/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {

    inserirAlerta(alerta) {

        return axiosJwt.post(`${api}/contratos/${alerta.idContrato}/alertas`, alerta)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    excluirAlerta(alerta) {
        return axiosJwt.delete(`${api}/contratos/${alerta.idContrato}/alertas/${alerta.alertaId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterAlertasPorContrato(idContrato) {
        return axiosJwt.get(`${api}/contratos/${idContrato}/alertas`)
        .then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })

    },
    obterAlertaPorId(idContrato, alertaId) {
        return axiosJwt.get(`${api}/contratos/${idContrato}/alertas/${alertaId}`)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    atualizarAlerta(alerta) {
        return axiosJwt.put(`${api}/contratos/${alerta.idContrato}/alertas/`, alerta)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    }

}